const nav = {
  // Het logo is een knop; dit is wat hij doet. Het plaatje zelf is daarmee
  // decoratief (alt=""), anders hoort een schermlezer het dubbel.
  logoToHome: 'Terug naar je overzicht',
  logoToTeam: 'Terug naar je teamoverzicht',
  myTeam: 'Mijn team',
  home: 'Home',
  intro: 'Eerst even uitleg',
  quiz: 'Test jezelf',
  // Web: de test zit in de app; dit label wijst naar het storescherm.
  app: 'De app',
  teamEnvironment: 'Teamomgeving',
  results: 'Resultaat',
  library: "Persona's",
  history: 'Historie',
  conversation: 'Mijn gesprek',
  admin: 'Admin',
  logout: 'Uitloggen',
  logoutWithEmail: (email) => `Uitloggen (${email})`,
  menu: 'Menu',
  close: 'Sluit',
  languageLabel: 'Taal',
  switchToEnglish: 'Schakel over naar Engels',
  switchToDutch: 'Schakel over naar Nederlands',
};

export default nav;
